module.exports = __webpack_public_path__ + "static/media/Feb27-S20.8fa1c1a5.png";